var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEmail, IsEnum, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { EmailType } from '../queue/email-type.js';
/**
 * Reference to a file the email worker downloads and attaches at send time.
 * The queue message carries a pre-signed URL, never inline file bytes.
 */
export class EmailAttachmentRefDto {
    url;
    filename;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], EmailAttachmentRefDto.prototype, "url", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], EmailAttachmentRefDto.prototype, "filename", void 0);
export class EmailDto {
    constructor() { }
    to;
    subject;
    attributes;
    officeLocationId;
    type;
    testMode;
    attachments;
    replyTo;
    html;
    sendToEmailAt = new Date();
}
__decorate([
    IsEmail(),
    Expose(),
    __metadata("design:type", String)
], EmailDto.prototype, "to", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], EmailDto.prototype, "subject", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], EmailDto.prototype, "attributes", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], EmailDto.prototype, "officeLocationId", void 0);
__decorate([
    IsEnum(EmailType),
    Expose(),
    __metadata("design:type", String)
], EmailDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], EmailDto.prototype, "testMode", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => EmailAttachmentRefDto),
    IsOptional(),
    __metadata("design:type", Array)
], EmailDto.prototype, "attachments", void 0);
__decorate([
    Expose(),
    IsEmail(),
    IsOptional(),
    __metadata("design:type", String)
], EmailDto.prototype, "replyTo", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], EmailDto.prototype, "html", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], EmailDto.prototype, "sendToEmailAt", void 0);
//# sourceMappingURL=email.dto.js.map